// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
// http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating

// requestAnimationFrame polyfill by Erik Möller. fixes from Paul Irish and Tino Zijdel

// MIT license

(function() {
    var lastTime = 0;
    var vendors = ['ms', 'moz', 'webkit', 'o'];
    for(var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
        window.requestAnimationFrame = window[vendors[x]+'RequestAnimationFrame'];
        window.cancelAnimationFrame = window[vendors[x]+'CancelAnimationFrame']
                                   || window[vendors[x]+'CancelRequestAnimationFrame'];
    }

    if (!window.requestAnimationFrame)
        window.requestAnimationFrame = function(callback, element) {
            var currTime = new Date().getTime();
            var timeToCall = Math.max(0, 16 - (currTime - lastTime));
            var id = window.setTimeout(function() { callback(currTime + timeToCall); },
              timeToCall);
            lastTime = currTime + timeToCall;
            return id;
        };

    if (!window.cancelAnimationFrame)
        window.cancelAnimationFrame = function(id) {
            clearTimeout(id);
        };
}());

window.requestTimeout = function(fn, delay) {
	var start = new Date().getTime(),
		handle = new Object();

	function loop(){
		var current = new Date().getTime(),
			delta = current - start;

		delta >= delay ? fn.call() : handle.value = requestAnimationFrame(loop);
	};

	handle.value = requestAnimationFrame(loop);
	return handle;
};

jQuery(function($) {
  'use strict';

  if($(".home:not(.housedocs) .masthead").length > 0) {

    var mastheadImg = $("section.masthead img");

    mastheadImg.on('transitionend webkitTransitionEnd oTransitionEnd otransitionend MSTransitionEnd', function(){
      // console.log("animation end");
    })


    var mastheadImages = $("section.masthead img");
    var mastheadIcon = $("section.masthead .animation");
    var mastheadTitles = $("section.masthead .animation .practice-titles li");


    playAnimation(mastheadImages, mastheadIcon, mastheadTitles, 0);

    function playAnimation(images, icon, titles, slide) {
      //$(animation).removeClass("animate");
      //$(icon).css("animation","none");
      var numOfItems = images.length;
      var prev;
      var next;



      if(slide===0) {
        prev = images.length-1;
        next = 1;
      } else if(slide === images.length-1) {
        prev = slide - 1;
        next = 0;
      } else {
        prev = slide - 1;
        next = slide + 1;
      }


      $(images[prev]).removeClass("animate");
      $(images[slide]).addClass("animate");
      $(icon).addClass("animate-rotate");
//       $(icon).css("animation","rotation 0.5s 1");
      $(titles[prev]).removeClass("animate-in");
      $(titles[slide]).addClass("animate-in");
      $(titles[prev]).addClass("animate-out");


      requestTimeout(function(){
//         $(icon).css("animation","none")
        $(icon).removeClass('animate-rotate');
        $(titles[prev]).removeClass("animate-out");
      },5000);



      requestTimeout(function(){playAnimation(images,icon,titles,next)},6000);
    }

  }

});